// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"373":"5d81f2275367c963","429":"c91ce319a7a32100","456":"c269eda55410693a"}[chunkId] + ".js";
};